"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHiddenInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHiddenInput = styled_components_1.default.input `
  border-radius: 4px;
  cursor: pointer;
  height: 40px;
  outline: none;
  position: absolute;
  width: 80%;
`;
